import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import _ from 'lodash'
import {
  Button,
  Col,
  Form, FormGroup,
  Input, Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap';

import Lang from 'Lang/General';
import { CreateFormData, FormSampleData, InvoiceFormData } from './assets';

const onHandleRoleVal = () => {
  if ( window.location.hash.indexOf( 'consultants' ) > -1 ){
    return 'CONSULTANT'
  }

  if ( window.location.hash.indexOf( 'speakers' ) > -1 ){
    return 'SPEAKER'
  }

  return `EXHIBITOR`
}

function CreateForm({
  data,
  errors,
  fairs,
  onSubmit,
  onClose,
  clientID,
  industries,
  countries
}) {
  const [ formData, setFormData ] = useState({
    ... FormSampleData,
    role: onHandleRoleVal(),
    client_id: clientID,
    center_id: data.selectCenterReducer.selectedCenter.center.id
  })

  useEffect(() => {
    let tmpFormData = _.cloneDeep( formData )

    if ( formData.role === 'SPEAKER' ){
      tmpFormData.is_also_speaker = false
      tmpFormData.is_multiple_brands = false
    }
    if ( formData.role !== 'EXHIBITOR' ){
      tmpFormData.is_newcomer = false
    }

    setFormData({ tmpFormData })
  }, [formData.role])

  useEffect(() => {
    setFormData({
      ... formData,
      username: formData.email,
    })
  }, [formData.email])

  const onChangeField = (key, val) => setFormData({
    ... formData,
    [key]: val
  })

  const onHandleSubmit = () => {
    let temp = _.cloneDeep(formData)
    InvoiceFormData(countries).map( field => {
      temp[field.value] = temp[field.value_to_copy]
    })

    onSubmit({
      ... temp,
      industries: _.map(formData.industries, child => child.id),
      fairs: _.map(formData.fairs, child => child.id)
    })
  }

  useEffect(() => {
    if(formData.role === 'CONSULTANT') {
      let tempConsulting = _.find(industries, child => child.label.toLowerCase() === 'consulting' )

      if (tempConsulting){
        let tempFindConsulting = _.find(formData.industries, child => child.id === tempConsulting.id)

        if (!tempFindConsulting) {
          setFormData({
            ... formData ,
            industries: [
              ... formData.industries,
              tempConsulting
            ]
          })

        }
      }
    }
  }, [formData.role])

  return (
    <>
      <ModalHeader toggle={ () => onClose() } >
        { Lang[ 'CREATE' ][ data.languageReducer.userSettings.admin_panel_language ] }
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
          {
            CreateFormData( industries, data.languageReducer.userSettings.admin_panel_language, fairs, formData ).map( formChild => (
              <Col key={ formChild.value } xl={ 6 } lg={ 6 } className={formChild.className || ''}>
                <FormGroup>
                  <Label className="d-flex mb-2 align-items-center">
                    {
                      Lang[ formChild.label ]
                        ? Lang[ formChild.label ][ data.languageReducer.userSettings.admin_panel_language ]
                        : formChild.label
                    }
                    <span className="text-danger">{ ` *`}</span>
                  </Label>
                  {
                    formChild.type.indexOf( 'select' ) < 0 && (
                      <Input
                        type={ formChild.type }
                        disabled={ formChild.disabled || false }
                        style={{
                          ... !_.isEmpty(errors) && errors[formChild.value] && {
                            borderColor: 'red'
                          }
                        }}
                        value={ formData[ formChild.value ] }
                        onChange={ e => onChangeField( formChild.value, e.target.value )}
                      />
                    ) 
                  }
                  {
                    formChild.type === 'select' && (
                      <Input
                        type={ formChild.type }
                        value={ formData[ formChild.value ] }
                        style={{
                          ... !_.isEmpty(errors) && errors[formChild.value] && {
                            borderColor: 'red'
                          }
                        }}
                        onChange={ e => onChangeField( formChild.value, e.target.value )}
                      >
                        {
                          formChild.options.map( child => (
                            <option value={ child.value }>{child.label}</option>
                          ))
                        }
                      </Input>
                    ) 
                  }
                  {
                    formChild.type === 'react-select' && (
                      <ReactSelect
                        isMulti
                        options={ formChild.options }
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: !_.isEmpty(errors) && errors[formChild.value] ? 'red' : 'hsl(0,0%,80%)',
                          }),
                        }}
                        onChange={ val => {
                          onChangeField( formChild.value, val )

                          if( formChild.value === 'fairs' && val.length < 1 && formData.status === 'CONFIRMED' ){
                            onChangeField( 'status', 'INTERESTED' )
                          } 
                        }}
                        value={ formData[formChild.value] }
                        placeholder={ Lang[ formChild.value === 'industries' ? 'SELECT_INDUSTRY' : "SELECT_FAIR" ][ data.languageReducer.userSettings.admin_panel_language ] }/>
                    )
                  }
                  {
                    !_.isEmpty(errors) && errors[formChild.value] && (
                      <small className="text-danger">{`${formChild.value} - `}{errors[formChild.value]}</small>
                    )
                  }
                </FormGroup>
              </Col>
            ))
          }
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => onHandleSubmit()}>
          { Lang[ 'SUBMIT' ][ data.languageReducer.userSettings.admin_panel_language ] }
        </Button>
      </ModalFooter>
    </>
  )
}

export default CreateForm